var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata } from "tslib";
import objectPath from "object-path";
import merge from "deepmerge";
import layoutConfig from "@/core/config/DefaultLayoutConfig";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import { Mutation, Module, VuexModule, Action } from "vuex-module-decorators";
let ConfigModule = class ConfigModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.config = layoutConfig;
        this.initial = layoutConfig;
    }
    /**
     * Get config from layout config
     * @returns {function(path, defaultValue): *}
     */
    get layoutConfig() {
        return (path, defaultValue) => {
            return objectPath.get(this.config, path, defaultValue);
        };
    }
    [_a = Mutations.SET_LAYOUT_CONFIG](payload) {
        this.config = payload;
    }
    [_b = Mutations.SET_CONTAINER_SIZE](containerType) {
        this.config.content.width = containerType;
    }
    [_c = Mutations.RESET_LAYOUT_CONFIG]() {
        this.config = Object.assign({}, this.initial);
        this.config.content.width = 'fluid';
    }
    [_d = Mutations.OVERRIDE_LAYOUT_CONFIG]() {
        this.config = this.initial = Object.assign({}, this.initial, JSON.parse(window.localStorage.getItem("config") || "{}"));
    }
    [_e = Mutations.OVERRIDE_PAGE_LAYOUT_CONFIG](payload) {
        this.config = merge(this.config, payload);
    }
    [_f = Actions.CHANGE_CONTAINER_TYPE](payload) {
        this.context.commit(Mutations.SET_CONTAINER_SIZE, payload);
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ConfigModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ConfigModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ConfigModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ConfigModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ConfigModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ConfigModule.prototype, _f, null);
ConfigModule = __decorate([
    Module
], ConfigModule);
export default ConfigModule;
//# sourceMappingURL=ConfigModule.js.map